export function initTabs() {
    [...document.querySelectorAll(".b-tabs")].forEach(el => new Tabs(el));
}

export class Tabs {
    constructor(el) {
        if (!el) return;

        this._dom = {
            tabs: el,
            tabTitles: el.querySelectorAll('.b-tabs__titles__name'),
            accordionTitles: el.querySelectorAll('.b-tabs__accordion-title'),
            tabContents: el.querySelectorAll('.b-tabs__content__inner')
        };

        this._breakpoint = 1023; // Mobile breakpoint
        this._currentActiveIndex = 0;

        this._initListeners();
        this._handleResponsiveness();

        // Add resize listener
        window.addEventListener('resize', () => this._handleResponsiveness());
    }

    _initListeners() {
        // Accordion titles listener
        this._dom.accordionTitles.forEach((title, index) => {
            title.addEventListener('click', () => {
                this._currentActiveIndex = index;
                this._toggleAccordion(index);
            });
        });
        this._dom.tabTitles.forEach((title, index) => {
            title.addEventListener('click', () => {
                this._currentActiveIndex = index;
                this._activateTab(index);
            });
        });
    }

    _activateTab(index, shouldScroll) {
        // Remove active class from all titles and contents
        this._dom.tabTitles.forEach(title => {
            title.classList.remove('-active');
        });

        this._dom.tabContents.forEach(content => {
            content.classList.remove('-active');
        });

        // Add active class to selected title and content
        const clickedTabTitle = this._dom.tabTitles[index];
        const clickedTabContent = this._dom.tabContents[index];

        clickedTabTitle.classList.add('-active');
        clickedTabContent.classList.add('-active');

        // Optional: Scroll functionality
        if (shouldScroll) {
            const offsetTop = this._getOffsetTop(this._dom.tabs);
            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }

    _toggleAccordion(index) {
        // Check if we're in mobile view
        if (window.innerWidth <= this._breakpoint) {
            const clickedAccordionTitle = this._dom.accordionTitles[index];
            const clickedTabContent = this._dom.tabContents[index];

            // Toggle active state
            if (clickedAccordionTitle.classList.contains('-active')) {
                clickedAccordionTitle.classList.remove('-active');
                clickedTabContent.classList.remove('-active');
            } else {
                // Remove active state from all
                this._dom.accordionTitles.forEach(title => {
                    title.classList.remove('-active');
                });
                this._dom.tabContents.forEach(content => {
                    content.classList.remove('-active');
                });

                // Add active to clicked
                clickedAccordionTitle.classList.add('-active');
                clickedTabContent.classList.add('-active');
            }
        }
    }

    _handleResponsiveness() {
        if (window.innerWidth <= this._breakpoint) {
            // Accordion mode
            this._dom.tabs.classList.add('-accordion');
            this._dom.tabs.classList.remove('-tabs');
        } else {
            // Tab mode
            this._dom.tabs.classList.remove('-accordion');
            this._dom.tabs.classList.add('-tabs');

            // Reset accordion states
            this._dom.accordionTitles.forEach(title => {
                title.classList.remove('-active');
            });
            this._dom.tabContents.forEach(content => {
                content.classList.remove('-active');
            });

            // Ensure first tab is active in desktop mode
            if(this._dom.tabContents[0]){
                this._dom.tabContents[0].classList.add('-active');
            }
        }
    }
}